import Class from "./Class";
import AVLTree from "./AVLTree";

const MappingTree = new Class({
    Extends: AVLTree,

    initialize: function(comparator) {
        AVLTree.call(this);
        this._comparator = comparator;
    },

    cmp: function(left, right) {
        return this._comparator.cmp(left.key, right.key);
    }
});

export default new Class({
    initialize: function(comparator) {
        this._tree = new MappingTree(comparator);
        this._count = 0;
    },

    _find: function(key) {
        return this._tree.find({"key": key});
    },

    get: function(key, _default) {
        const node = this._find(key);
        if (node !== null) {
            return node.value().value;
        } else if (arguments.length >= 2) {
            return _default;
        }
        return null;
    },

    set: function(key, value) {
        const node = this._find(key);
        if (node !== null) {
            node.value().value = value;
        } else {
            this._tree.insert({
                "key": key,
                "value": value
            });
            this._count += 1;
        }
    },

    pop: function(key, _default) {
        const node = this._find(key);
        if (node !== null) {
            const item = node.value();
            node.remove();
            this._count -= 1;
            return item.value;
        } else if (arguments.length >= 2) {
            return _default;
        }
        return null;
    },

    count: function() {
        return this._count;
    },

    contains: function(key) {
        return this._count > 0 && this._find(key) !== null;
    },

    nextValue: function(key, _default) {
        const node = this._find(key);
        const next = node === null ? null : node.next();
        if (next !== null) {
            return next.value().value;
        } else if (arguments.length >= 2) {
            return _default;
        }
        return null;
    },

    forEach: function(func, ctx) {
        let node = this._tree.min();

        while (node !== null) {
            const item = node.value();
            func.call(ctx, item.value, item.key, this);
            node = node.next();
        }
    },

    keys: function() {
        const result = new Array(this._count);
        let index = 0;

        this.forEach(function(value, key) {
            result[index++] = key;
        });

        return result;
    }
});



// WEBPACK FOOTER //
// ./src/abusesa-js/Mapping.js